<h1 class="tw-mt-6 tw-mb-2 tw-pb-2.5">{{ "changeMasterPassword" | i18n }}</h1>

<div class="tw-max-w-lg tw-mb-12">
  <bit-callout type="warning">{{ "loggedOutWarning" | i18n }}</bit-callout>
  <auth-change-password [inputPasswordFlow]="inputPasswordFlow"></auth-change-password>
</div>

<app-webauthn-login-settings></app-webauthn-login-settings>
